import MainPage from "./components/core/MainPage/MainPage";
import RedirectPage from "./components/core/MainPage/RedirectPage";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Layout from "./components/core/Layout/Layout";
import SearchContent from "./components/Search/SearchContent/SearchContent";
import TagCategory from "./components/TagCategory/TagCategory/TagCategory";
import NotFound from "./components/error/NotFound/NotFound";
import ServerError from "./components/error/ServerError/ServerError";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="*" element={<Layout />}>
          <Route path="404" element={<NotFound />} />
          <Route path="500" element={<ServerError />} />
          <Route
            path="support/"
            element={<Navigate to="/support/get-help" replace />}
          />
          <Route
            path="listento"
            element={<Navigate to="/products/listento" replace />}
          />
          <Route
            path="listento-ga-lg"
            element={<Navigate to="/products/listento-ga-long" replace />}
          />
          <Route
            path="listento-adr-lg/"
            element={<Navigate to="/products/listento-adr-lg" replace />}
          />
          <Route
            path="listento-adr-sh/"
            element={<Navigate to="/products/listento-adr-sh" replace />}
          />
          <Route
            path="listento-fb-sh/"
            element={<Navigate to="/products/listento-fb-sh" replace />}
          />
          <Route
            path="listento-ga-short/"
            element={<Navigate to="/products/listento-ga-short" replace />}
          />
          <Route
            path="listento-ga-lg/"
            element={<Navigate to="/products/listento-ga-lg" replace />}
          />
          <Route
            path="listento-short/"
            element={<Navigate to="/products/listento-short" replace />}
          />
          <Route
            path="istento-fb-lg/"
            element={<Navigate to="/products/listento-fb-lg" replace />}
          />
          <Route
            path="omnibus"
            element={<Navigate to="/products/omnibus" replace />}
          />
          <Route
            path="inject"
            element={<Navigate to="/products/inject" replace />}
          />
          <Route
            path="minibus"
            element={<Navigate to="/products/minibus" replace />}
          />
          <Route
            path="binaural-renderer-for-apple-music"
            element={
              <Navigate
                to="/products/binaural-renderer-for-apple-music"
                replace
              />
            }
          />
          <Route
            path="aircaster"
            element={<Navigate to="/products/aircaster" replace />}
          />
          <Route
            path="audiomovers-for-business"
            element={<Navigate to="/sectors/business" replace />}
          />
          <Route
            path="audiomovers-for-education"
            element={<Navigate to="/sectors/education" replace />}
          />
          <Route
            path="audiomovers-for-students"
            element={<Navigate to="/sectors/students" replace />}
          />
          <Route
            path="case-studies"
            element={<Navigate to="/news" replace />}
          />
          <Route path="help" element={<Navigate to="/support" replace />} />
          <Route
            path="help/faq"
            element={<Navigate to="/support/get-help" replace />}
          />
          <Route
            path="help/guides"
            element={<Navigate to="/support/product" replace />}
          />
          <Route
            path="bundles"
            element={<Navigate to="/solutions/remote-collaboration" replace />}
          />
          <Route path="wp/about" element={<Navigate to="/about" replace />} />
          <Route
            path="wp/downloads"
            element={<Navigate to="/downloads" replace />}
          />
          <Route path="search" element={<SearchContent />} />
          <Route path="tag/:tag" element={<TagCategory />} />
          <Route path="category/:category" element={<TagCategory />} />
          <Route path="" element={<MainPage />} />
          <Route path="*" element={<RedirectPage />} />
        </Route>
      </Routes>
    </Router>
  );
}
export default App;
